@if (filled() === 'half') {
<span class="star-half-left star">
  <fa-icon [icon]="['fas', 'star-half']" />
</span>
<span class="star-empty star-half-right star star-margin">
  <fa-icon [icon]="['fas', 'star-half']" transform="flip-h" />
</span>
} @else {
<span class="star star-margin" [ngClass]="[filled() === 'full' ? '' : 'star-empty']">
  <fa-icon [icon]="['fas', 'star']" />
</span>
}
